import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export interface Country {
  code: string
  nameEn: string
  nameFr: string
  name: string
  continentCode: string
}

const fetchCountries = async ({ pageParam = '1', continent, continents, lang, search }: FetchParams): Promise<PaginatedResponse<Country>> => {
  const params = new URLSearchParams()
  params.append('page', pageParam)
  if (continent) {
    params.append('continent', continent)
  }
  if (continents?.length) {
    continents.forEach((c: string) => params.append('continents', c))
  }
  if (lang) {
    params.append('lang', lang)
  }
  if (search) {
    params.append('search', search)
  }
  
  const { data } = await api.get<PaginatedResponse<Country>>(`/countries?${params.toString()}`)
  return data
}

export const usePaginateCountries = ({
  continent,
  continents,
  lang,
  search,
}: {
  continent?: string
  continents?: string[]
  lang?: 'en' | 'fr' | 'es'
  search?: string
}) => {
  return usePaginate<Country>('countries', fetchCountries, { continent, continents, lang, search })
}

